import CustomIcons from "../../GlobalComponents/CustomIcons";
import React, { Component } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "ckeditor5-pys-custom-build";
import FetchResponses from "../../../models/FetchResponses";
import Auth from "../../../models/Auth";
import settings from "../../../settings";
import ReactHtmlParser from "react-html-parser";
import { Messages } from "../../../models/Messages";
import Error from "../../PublicViews/Error";
import PageLoader from "../../GlobalComponents/PageLoader";
import { Modal } from 'antd'


class EditFaq extends Component {
  confirm = Modal.confirm
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      open:false,
      error_message: '',
      preguntas: this.props.preguntas,
      editQuestion: false,
      preguntaToSave: {},
      tags: [],
      input: "",
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.saveCard = this.saveCard.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
  }

  handleClose () {
    
  }

  saveCard = () => {
    this.setState({ loading: true })
    let position = this.state.preguntaToSave.extra_properties.position
      ? parseInt(this.state.preguntaToSave.extra_properties.position)
      : parseInt(this.state.FAQ.length - 1);

    let tags = this.state.preguntaToSave.extra_properties.tags || [];

    const data = {
      ...this.state.preguntaToSave,
      module_type: "FAQ",
      image_link: "https://www.alkomprar.com/",
      redirect_link: "https://www.alkomprar.com/",
      extra_properties: {
        position: position,
        tags,
      },
    };
    
    fetch(settings.backend.front_modules, {
      method: "POST",
      body: JSON.stringify(data),
      headers: settings.headers_auth(Auth.getSessionToken()),
    })
      .then(FetchResponses.processResponse)
      .then(this.successChangue)
      .catch((error) => {
        console.log(error);
      });
  };

  successChangue = async (response) => {
    this.props.refresh()
    this.setState({ loading: false, editQuestion: false})
  };

  handleChangeEdit = (event) => {
    const { id, value } = event.target;
    if (id == "position") {
      this.setState((prevState) => ({
        preguntaToSave: {
          ...prevState.preguntaToSave,
          extra_properties: {
            ...prevState.preguntaToSave.extra_properties,
            position: value,
          },
        },
      }));
    } else {
      this.setState((prevState) => ({
        preguntaToSave: {
          ...prevState.preguntaToSave,
          [id]: value,
        },
      }));
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.preguntas !== this.props.preguntas) {
      this.setState({preguntas: this.props.preguntas})
    }
  }

  handleOnChangeDetail = (event, editor) => {
    const data = editor.getData();
    this.setState((prevState) => ({
      preguntaToSave: {
        ...prevState.preguntaToSave,
        content: data,
      },
    }));
  };

  handleInputChange = (e) => {
    this.setState({ input: e.target.value });
  };

  handleKeyDown = (e) => {
    const { input, preguntaToSave } = this.state;

    if (e.key === "Enter" && input.trim()) {
      e.preventDefault();

      const trimmedInput = input.trim();
      const pregunta = { ...preguntaToSave };

      // Asegurar que extra_properties exista
      if (!pregunta.extra_properties) {
        pregunta.extra_properties = {};
      }

      // Asegurar que tags exista
      if (!Array.isArray(pregunta.extra_properties.tags)) {
        pregunta.extra_properties.tags = [];
      }

      // Agregar el tag si no existe
      if (!pregunta.extra_properties.tags.includes(trimmedInput)) {
        pregunta.extra_properties.tags = [
          ...pregunta.extra_properties.tags,
          trimmedInput,
        ];

        this.setState({
          input: "",
          preguntaToSave: pregunta,
        });
      }
    }
  };

  removeTag = (indexToRemove) => {
    const { preguntaToSave } = this.state;
    preguntaToSave.extra_properties.tags =
      preguntaToSave.extra_properties.tags.filter(
        (_, index) => index !== indexToRemove
      );

    this.setState({
      preguntaToSave: preguntaToSave,
    });
  };

  renderForm() {
    let { preguntaToSave } = this.state;
    return (
      <form className="form-edit-cards" onSubmit={this.saveCard}>
        <div>
          <span className="carrusel--subtitle">Pregunta</span>
          <input
            type="text"
            className="form-control"
            //readOnly
            value={preguntaToSave.title}
            onChange={this.handleChangeEdit}
            field="title"
            id="title"
            placeholder="Titulo"
            required
          />
        </div>

        <div>
          <span className="carrusel--subtitle">Respuesta</span>
          <CKEditor
            editor={ClassicEditor}
            config={{
              toolbar: ["underline", "bold", "italic", "link", "undo", "redo"],
              image: {},
              table: {},
              extraPlugins: [],
            }}
            data={preguntaToSave.content}
            onReady={(editor) => {}}
            onChange={this.handleOnChangeDetail}
          />
        </div>

        <div>
          <span className="carrusel--subtitle">Orden</span>
          <input
            type="text"
            className="form-control"
            onChange={this.handleChangeEdit}
            //readOnly
            value={preguntaToSave.extra_properties.position}
            field="position"
            id="position"
            placeholder="position"
            required
          />
        </div>

        <div>
          <span className="carrusel--subtitle">Etiquetas</span>
          <div className="edit-tag-container">
            {preguntaToSave.extra_properties.tags &&
              preguntaToSave.extra_properties.tags.map((tag, index) => (
                <div className="faq-collapsible-tag" key={index}>
                  {tag}
                  <CustomIcons
                    className="tag-close-icon"
                    icon={"closeCircle"}
                    onClick={() => this.removeTag(index)}
                  />
                </div>
              ))}
          </div>
          <input
            type="text"
            className="form-control"
            value={this.state.input}
            onChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            placeholder="Presiona Enter para agregar"
          />
        </div>

        <div className="form-edit-cards-buttons">
          <button
            className="btn btn-outline-secondary"
            onClick={() => {
              this.setState({ editQuestion: false });
            }}
            type="button"
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            style={{ background: "#a00", borderColor: "#a00" }}
            type="submit"
          >
            Guardar
          </button>
        </div>
      </form>
    );
  }

  handleEdit(event) {
    let idcard = event.currentTarget.getAttribute("idPregunta");
    let editableCard = this.state.preguntas.filter(
      (pregunta) => pregunta.name == idcard
    )[0];
    this.setState({ editQuestion: true, preguntaToSave: editableCard });
  }

  handleCreate() {

    let data = {
      name: "data" + Math.random(),
      thumbUrl:
        "https://cdn.pixabay.com/photo/2017/11/10/05/24/upload-2935442_960_720.png",
      content: "",
      module_type: "",
      redirect_link: "",
      image_link:
        "https://cdn.pixabay.com/photo/2017/11/10/05/24/upload-2935442_960_720.png",
      title: "",
      create: true,
      extra_properties: { position: this.state.preguntas.length + 1, tags: [] },
    };

    this.setState({ editQuestion: true, preguntaToSave: data });
  }

  deleteFAQ = (event) => {
    let _this = this
    let idcard = event.currentTarget.getAttribute("idPregunta");
    let editableCard = _this.state.preguntas.filter(
      (pregunta) => pregunta.name == idcard
    )[0];
    this.confirm({
      content: `¿Está seguro de que desea eliminar la pregunta`,
      okText: 'Sí',
      cancelText: 'Cancelar',
      confirmLoading: this.state.loading,
      onOk() {
        const data = {
          name: editableCard.name,
          image_link: "https://www.alkomprar.com/",
          content: editableCard.content,
          extra_properties: {},
          module_type: "FAQ",
          redirect_link: "https://www.alkomprar.com/",
          title: editableCard.name,
        };

        fetch(settings.backend.front_modules, {
          method: "DELETE",
          body: JSON.stringify(data),
          headers: settings.headers_auth(Auth.getSessionToken()),
        })
          .then(FetchResponses.processResponse)
          .then(_this.successChangue)
          .catch((error) => {
            _this.handleErrorMessage(Messages.errorTryLater);
        });
      },
      onCancel() { },
    })  
  };

  renderTable() {
    return (
      <div style={{ width: "100%" }}>
        <div className="table-responsive">
          <>{this.state.editQuestion}</>
          <table
            className="table table-striped table-sm"
            style={{ overflowX: "auto", whiteSpace: "nowrap" }}
          >
            <thead>
              <tr style={{ fontSize: "1.6em" }}>
                <th className="text-left-important" scope="col">
                  Pregunta
                </th>
                <th className="text-left-important" scope="col">
                  Respuesta
                </th>
                <th className="text-left-important" scope="col">
                  Orden
                </th>
                <th className="text-left-important" scope="col">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody style={{ fontSize: "1.4em" }}>
              {this.state.preguntas.length > 0 &&
                this.state.preguntas.map((pregunta, index) => {
                  return (
                    <tr key={pregunta.id}>
                      <td
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "250px", // Ajusta este valor según el ancho deseado
                        }}
                      >
                        {pregunta.title}
                      </td>
                      <td
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "300px", // Ajusta este valor según el ancho deseado
                        }}
                      >
                        {ReactHtmlParser(pregunta.content)}
                      </td>
                      <td>{pregunta.extra_properties.position}</td>
                      <td>
                        <button
                          className="non-button ms-2"
                          idPregunta={pregunta.name}
                          type="button"
                          onClick={this.handleEdit}
                        >
                          <span className="icon dripicons-pencil" />
                        </button>

                        <button
                          className="non-button ms-2"
                          idPregunta={pregunta.name}
                          type="button"
                          onClick={this.deleteFAQ}
                        >
                          <span className="icon dripicons-trash" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleCreate}
        >
          Crear Pregunta
        </button>
      </div>
    );
  }
  render() {
    const { editQuestion } = this.state;
    return (
      <>
        {editQuestion ? this.renderForm() : this.renderTable()}

        <Error
          open={this.state.open}
          error_message={this.state.error_message}
          handleClose={this.handleClose}
        />
        {this.state.loading && <PageLoader/>}
      </>
    );
  }
}

export default EditFaq;
